import React from "react";
import { useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import "./Home.css";

function Home() {
    const navigate = useNavigate();

    const handleSignIn = () => {
        navigate("/sign-in");
    };

    const handleSignNDA = () => {
        navigate("/sign-nda");
    };

    const mobileUrl = "https://visitors.tail2cfc0.ts.net/mobile";

    return (
        <div className="home">
            <main className="main">
                <div className="content-container">
                    <img
                        src="/logo_SDBLACK.png"
                        alt="Sound Disposition"
                        className="logo"
                    />
                    <h1 className="title">Welcome to Sound Disposition</h1>
                    <div className="ipad-layout">
                        <div className="qr-section">
                            <p className="qr-label">Scan to sign in on your phone</p>
                            <QRCodeSVG
                                value={mobileUrl}
                                size={200}
                                bgColor="#ffffff"
                                fgColor="#3a3a3a"
                                level="M"
                            />
                        </div>
                        <div className="button-container">
                            <button
                                className="portal-button"
                                onClick={handleSignIn}
                            >
                                Visitor Sign In
                            </button>
                            <button
                                className="portal-button"
                                onClick={handleSignNDA}
                            >
                                Sign NDA
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default Home;
